module.exports = __webpack_public_path__ + "img/1082.4407fe6a.gif";